import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import SimpleBar from "simplebar-react";
import logoSm from "../assets/images/amazingpark-logo.png";
import logoDark from "../assets/images/amazingcamp_big_logo.png";
import logoLight from "../assets/images/amazingcamp_big_logo_dark.png";

import VerticalLayout from "./VerticalLayouts";
import { useLayoutStore } from "../store/useLayoutStore";
import ProfileDropdown from '../Components/Common/ProfileDropdown';
import { useAuthContext } from "../Components/AuthContext";

const Sidebar = ({ onToggleSidebar }: any) => {
  const { logout } = useAuthContext();
  const layoutType = useLayoutStore((state) => state.layoutType);

  useEffect(() => {
    const overlay = document.querySelector('.vertical-overlay');

    if (!overlay) {
      return undefined;
    }

    const handleOverlayClick = () => {
      document.body.classList.remove('vertical-sidebar-enable');
    };

    overlay.addEventListener('click', handleOverlayClick);

    return () => {
      overlay.removeEventListener('click', handleOverlayClick);
    };
  }, []);

  return (
    <React.Fragment>
      <div className="app-menu navbar-menu flex h-full min-h-0 flex-col overflow-hidden">
        <div className="navbar-brand-box shrink-0 flex h-15 items-center justify-center border-b border-slate-800 bg-slate-900 px-4">
          <Link to="/" className="logo logo-dark">
            <span className="logo-sm">
              <img src={logoSm} alt="" height="22" />
            </span>
            <span className="logo-lg">
              <img src={logoDark} alt="" height="42" />
            </span>
          </Link>

          <Link to="/" className="logo logo-light">
            <span className="logo-sm">
              <img src={logoSm} alt="" height="22" />
            </span>
            <span className="logo-lg">
              <img src={logoLight} alt="" height="42" />
            </span>
          </Link>
          <button
            onClick={onToggleSidebar}
            type="button"
            className="header-item ml-auto inline-flex items-center justify-center text-xl text-slate-400 hover:text-slate-200"
            id="vertical-hover"
          >
            <i className="ri-record-circle-line"></i>
          </button>
        </div>

        {/* Profile Dropdown */}
        <div className="sidebar-profile-row shrink-0 border-b border-slate-800 px-2">
          <ProfileDropdown onLogout={logout} />
        </div>

        <React.Fragment>
          <SimpleBar id="scrollbar" className="sidebar-menu-scroll min-h-0 flex-1">
            <div className="px-4 py-2">
              <div id="two-column-menu"></div>
              <ul className="navbar-nav flex flex-col gap-1" id="navbar-nav">
                <VerticalLayout layoutType={layoutType} />
              </ul>
            </div>
          </SimpleBar>
          <div className="sidebar-background"></div>
        </React.Fragment>
      </div>
      <div className="vertical-overlay"></div>
    </React.Fragment>
  );
};

export default Sidebar;
